import React from 'react';
import classnames from 'classnames';
import { ColumnComponentProps } from 'v2/utils/searchViewUtils';

const TitleDetailed = ({ search }: ColumnComponentProps) => {
  return (
    <div className="flex-row multiline-truncate-3 text-justify">
      <div className={classnames('d-inline-block', 'search-title')}>
        <p
          className={classnames(
            'text-break mb-2 pr-5',
            'title-for-review-search'
          )}
        >
          {search.name}
        </p>
        <p
          className={classnames(
            'text-break multiline-truncate-3 pr-5',
            'description-for-review-search'
          )}
        >
          {search.description}
        </p>
      </div>
    </div>
  );
};

export default TitleDetailed;
